import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import appConfigCoverGoProdME from "./appConfigCoverGoProdME.js"
import { COVERGO_ASIA_PROD, COVERGO_ME_PROD, COVERGO_ASIA_QA, COVERGO_CA_PROD } from "../consts.js"

export const coverHealth = {
	"coverHealth-uat-studio.quote.hk": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_ASIA_PROD },
	"studio.me.covergo.com": { appConfig: appConfigCoverGoProdME, envConfig: COVERGO_ME_PROD },
}

export const cvhl_core = {
	"cvhl-core-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "cvhl_core",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-cvhl-core-qa"
		}
	},
}

export const coverHealth_ca_prod = {
	"cover-health-studio.ca.covergo.com": {
		appConfig: {
			tenantId: "coverHealth_ca_prod",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_CA_PROD,
		fileSystem: {
			bucketName: "covergo-cace1-prod-coverhealth"
		}
	},
}